import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { isNumber } from '@sparling/financial-common'

const Schema = yup.object().shape({
  asset: yup.string().ensure().required('Please select'),
  amount: yup
    .string()
    .required('Please input a number')
    // eslint-disable-next-line
    .test('isNumber', 'Must be a numeric value', (value: any): boolean => isNumber(value))
    // eslint-disable-next-line
    // .test(
    //   'maxAmount',
    //   'Maximum amount to stake asset is 99999999',
    //   // eslint-disable-next-line
    //   (value: any): boolean => isNumber(value) && value <= 99999999,
    // )
    // eslint-disable-next-line
    // .test(
    //   'minAmount',
    //   'Minimum amount to stake asset is 100$',
    //   // eslint-disable-next-line
    //   (value: any): boolean => isNumber(value) && value >= 100,
    // )
    // eslint-disable-next-line
    .test('isPositiveNumber', 'Must be a positive numeric value', (value: any): boolean =>
      /^\+?(\d+(\.(\d+)?)?|\.\d+)$/.test(value),
    )
    // eslint-disable-next-line
    // .test('isPositiveNumber', 'Max 8 digits after point', (value: any): boolean => /^[0-9]+\.?[0-9]{0,8}$/.test(value))
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => Number(value) > 0)
    // eslint-disable-next-line
    .test('isNotZero', 'Must be a positive numeric value', (value: any): boolean => value >= 0)
    .nullable(true),
})

export const resolver = yupResolver(Schema)
